import { render, staticRenderFns } from "./excellentcases_detail.vue?vue&type=template&id=50a3c4df&scoped=true&"
import script from "./excellentcases_detail.vue?vue&type=script&lang=js&"
export * from "./excellentcases_detail.vue?vue&type=script&lang=js&"
import style0 from "./excellentcases_detail.vue?vue&type=style&index=0&id=50a3c4df&scoped=scoped&lang=scss&"
import style1 from "./excellentcases_detail.vue?vue&type=style&index=1&id=50a3c4df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a3c4df",
  null
  
)

export default component.exports